import {
  AxiosRequestConfig,
  AxiosRequestHeaders,
  InternalAxiosRequestConfig,
} from "axios";
import {
  T_GenerateTokenRes,
  T_GetCustomerLobDetailsRes,
} from "../features/Feature_Login/Login_Types";
import { Route } from "react-router-dom";
import { T_ProductCategoryOptions } from "../features/Feature_GeneralAppElements/GeneralAppElements_Types";
import { InAppFeatureFuncCodes } from "../utils/constants";
import {
  R_HiRoutes,
  R_HLRoutes,
  R_HomeRoutes,
  R_LiRoutes,
  R_MfRoutes,
  R_SSRoutes,
} from "../utils/Routes";

export type AxiosFetchQuery = {
  url: string;
  method?: AxiosRequestConfig["method"];
  data?: AxiosRequestConfig["data"];
  body?: AxiosRequestConfig["data"];
  params?: AxiosRequestConfig["params"];
  headers?: AxiosRequestConfig["headers"];
};
export type T_ApiResponse<T> = {
  code: number;
  message: string;
  payload: T;
  uiDisplayMessage: string;
  uiDisplayTitle: string;
  rootCause?: string;
  errorCode?: string;
  config?: InternalAxiosRequestConfig;
  headers?: AxiosRequestHeaders;
};

export type T_UserProfile = {
  name?: string;
  pan?: string;
  dob?: string;
  mobileNumber?: string;
  emailId?: string;
};

export type T_Update_UserProfile_Request = {
  csUserId?: string;
  name?: string;
  pan?: string;
  dob?: string;
  mobile?: string;
  emailId?: string;
};

export enum E_ChannelOptions {
  CSAPP = "CSAPP",
  SUPER_APP = "SUPER APP",
  ONE_ABC = "ABCAPP",
  SECONDARY_CHANNEL = "SECONDARY CHANNEL",
  ABSLI = "ABSLI",
  ABHI = "ABHI",
  ABSLAMC = "ABSLAMC",
  ABML = "ABML",
  ABHFL = "ABHFL",
  ABFL = "ABFL",
}

export type UserPayload = {
  uuid: string | undefined;
  linkedlobs: string;
  userName: string;
  iat: number;
  exp: number;
  functionalitycode: string;
  LOB: string;
};

export type UserPayloadChatBot = {
  uuid: string | undefined;
  channel: string;
  linkedLobs: string;
  userName: string;
  iat: number;
};

export type T_NavtiveDeviceInfo = {
  deviceName: string;
  systemVersion: number;
  deviceModel: string;
  identifier: string;
  systemName: string;
  appVersion: string;
  isFirstInstall: boolean;
  bioInfo?: T_BioInfo | null;
};

export type T_BioInfo = {
  biometricToken: string;
  mobile: string;
  csUserId: string;
  deviceId: string;
};

export type T_CsAppSliceState = {
  userDetails: (T_UserProfile & T_CustomerLobDetails) | undefined;
  tokenDetails: T_AuthToken | undefined;
  userAgent: T_UserAgent | undefined;
  traceId: string | undefined;
  deviceType: string | undefined;
  NativeDeviceInfo: T_NavtiveDeviceInfo | undefined;
  channel: E_ChannelOptions;
  platform: string;
  csUserId: string;
  ipAddress: string;
  emailId: string;
};

export type T_CsErrorSliceState = {
  error: T_ApiResponse<any> | Error | undefined;
  message: string | undefined;
  customTitle?: string;
  customSubTitle?: string;
  customButtonLabel?: string;
};

export type T_AuthToken = T_GenerateTokenRes;
export type T_LogoutInfoToBePassed = {
  token: string;
  bio_token: string;
  supportingData?: {
    mobile: string;
    destinationLobId: string;
    sourceLobId: string;
    functionalityCode: string;
    isOnBoarding: string;
    isExtensionRequired: string;
    pan: string;
    dob: string;
    email: string;
  };
  clearLocalStorage?: boolean;
};
export type T_UserAgent = {
  deviceId: string;
  platform: string;
  deviceType: string;
  browserName: string;
  browserVersion: string;
};

export type T_UserType = {
  id: number;
  email: string;
  password: string;
  name: string;
  role: string;
  avatar: string;
};

export type T_CustomerLobDetails = T_GetCustomerLobDetailsRes;

export enum LoginScreenValues {
  enterMobileScreen = "enterMobileScreen",
  LoginWithMPIN = "LoginWithMPIN",
  enterOtpScreen = "enterOtpScreen",
  enterMobileScreenForgotPin = "enterMobileScreenForgotPin",
  enterOtpScreenForgotmPIN = "enterOtpScreenForgotmPIN",
  enterUserDetailScreen = "enterUserDetailScreen",
  setupMPN = "setupMPN",
  fetchCustomerLobAndDo2FAAuth = "fetchCustomerLobAndDo2FAAuth",
  loading = "loading",
}

export type T_AnimationData = {
  v: string;
  fr: number;
  ip: number;
  op: number;
  w: number;
  h: number;
  nm: string;
  ddd: number;
  assets: any[];
  layers: any[];
};

export type T_Option = {
  label: string;
  value: string;
};
export const J_FunctionalityCode = [
  {
    funcCode: InAppFeatureFuncCodes.LI_DETAILS_PAGE,
    name: "MF_DETAILS_PAGE",
    route: `${R_MfRoutes.mutualFund_Details}`,
    isDynamicPath: false,
    dynamicKeys: ["panNumber"],
    lobCode: ["01"],
  },
  {
    funcCode: "01QADP",
    name: "MF_QUICK_ACTIONS_DETAILS_PAGE",
    route: `${R_MfRoutes.mutualFund_Details}?action=quickAction`,
    isDynamicPath: false,
    dynamicKeys: ["panNumber"],
    lobCode: ["01"],
  },
  {
    funcCode: "01TQA",
    name: "MF_TRANSACT_QUICK_ACTIONS_DETAILS_PAGE",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: ["panNumber"],
    lobCode: ["01"],
  },
  {
    funcCode: "01MSQA",
    name: "MF_MY_STATEMENTS_QUICK_ACTIONS_DETAILS_PAGE",
    route: `${R_MfRoutes.mutualFund_Details}?action=myStatementsList`,
    isDynamicPath: false,
    dynamicKeys: ["panNumber"],
    lobCode: ["01"],
  },
  {
    funcCode: "01GAS",
    name: "ACCOUNT_STATEMENT",
    route: `${R_MfRoutes.mutualFund_AccountStatement}`,
    isDynamicPath: false,
    dynamicKeys: ["panNumber"],
    lobCode: ["01"],
  },
  {
    funcCode: "01CGS",
    name: "CAPITAL_GAIN_STATEMENT",
    route: `${R_MfRoutes.mutualFund_CapitalGains}`,
    isDynamicPath: false,
    dynamicKeys: ["panNumber"],
    lobCode: ["01"],
  },
  {
    funcCode: "01ELS",
    name: "EXIT_LOAD_STATEMENT",
    route: `${R_MfRoutes.mutualFund_ExitLoad}`,
    isDynamicPath: false,
    dynamicKeys: ["panNumber"],
    lobCode: ["01"],
  },
  {
    funcCode: "RDM",
    name: "REDEEM_STATEMENTS",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "STP",
    name: "STP",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "SWP",
    name: "SWP",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "SWITCH",
    name: "SWITCH",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "SIP",
    name: "PAUSE/CANCEL SIP",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "SF1",
    name: "SF",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "BNK",
    name: "BNK",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "OTM",
    name: "Register OTM",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "AMNOMINEE",
    name: "Add Modify Nominee",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "CHNGCNTCT",
    name: "Change Contact",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "WHTSOPTIN",
    name: "WHATS APP OPT IN",
    route: `${R_MfRoutes.mutualFund_Details}?action=transactList`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "TS",
    name: "TS",
    route: `${R_MfRoutes.mutualFund_Details}`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "24MPD",
    name: "MY_PORTFOLIO",
    route: `${R_SSRoutes.details_Portfolio}`,
    isDynamicPath: false,
    dynamicKeys: ["mobileNo"],
    lobCode: ["24"],
  },
  {
    funcCode: "24QA",
    name: "STOCKS_QUICK_ACTION",
    route: `${R_SSRoutes.details_Portfolio}?quickAction=true`,
    isDynamicPath: false,
    dynamicKeys: ["mobileNo"],
    lobCode: ["24"],
  },
  {
    funcCode: "24MD",
    name: "SS_MY_DOCUMENT",
    route: `${R_SSRoutes.details_Portfolio_MyDocuments}`,
    isDynamicPath: false,
    dynamicKeys: ["mobileNo"],
    lobCode: ["24"],
  },
  {
    funcCode: "24SA",
    name: "SS_STATEMENT_OF_ACCOUNTS",
    route: `${R_SSRoutes.account_statement}`,
    isDynamicPath: false,
    dynamicKeys: ["mobileNo"],
    lobCode: ["24"],
  },
  {
    funcCode: "24ST",
    name: "SS_STATEMENT_OF_TRANSACTION",
    route: `${R_SSRoutes.details_Portfolio_MyDocuments}`,
    isDynamicPath: false,
    dynamicKeys: ["mobileNo"],
    lobCode: ["24"],
  },
  {
    funcCode: "24CG",
    name: "SS_CAPITAL_GAIN",
    route: `${R_SSRoutes.details_Portfolio_MyDocuments}`,
    isDynamicPath: false,
    dynamicKeys: ["mobileNo"],
    lobCode: ["24"],
  },
  {
    funcCode: "24CN",
    name: "SS_CONTRACT_NOTE",
    route: `${R_SSRoutes.contact_notes}`,
    isDynamicPath: false,
    dynamicKeys: ["mobileNo"],
    lobCode: ["24"],
  },
  {
    funcCode: "02VDP",
    name: "LI_VIEW_DETAILS_PAGE",
    route: `${R_LiRoutes.details_PolicyNumber}`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02SDVDP",
    name: "LI_SERVICE_DRAWER_ON_VIEW_DETAILS_PAGE",
    route: `${R_LiRoutes.details_PolicyNumber}?action=serviceDrawer`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02UPSD",
    name: "LI_WHATSAPP_OPT_IN_OUT,LI_UPDATE_MOBILE_NUMBER,LI_UPDATE_EMAIL",
    route: `${R_LiRoutes.details_PolicyNumber}?action=updateProfileList`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02WHTS_IN_OUT",
    name: "LI_WHATSAPP_OPT_IN_OUT",
    route: `${R_LiRoutes.details_PolicyNumber}?action=updateProfileList`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02UPMONU",
    name: "LI_UPDATE_MOBILE_NUMBER",
    route: `${R_LiRoutes.details_PolicyNumber}?action=updateProfileList`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02UPEM",
    name: "LI_UPDATE_EMAIL",
    route: `${R_LiRoutes.details_PolicyNumber}?action=updateProfileList`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02UP",
    name: "LI_UPDATE_PAN",
    route: `${R_LiRoutes.details_PolicyNumber_UpdatePAN}`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02PSD",
    name: "LI_PAY_PREMIUM,LI_REINSTATE_POLICY,LI_CHANGE_PAYMENT_FREQ,LI_SETUP_ENACH,LI_SETUP_ESI,LI_REPAY_LOAN",
    route: `${R_LiRoutes.details_PolicyNumber}?action=paymentList`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02PSSD",
    name: "LI_APPLY_FOR_LOAN,LI_ADD_NOMINEE,LI_UPDATE_NOMINEE,LI_ADD_UPDATE_BANK_ACCOUNT,LI_SET_ALERTS,LI_FUND_SWITCH,LI_FILE_CLAIMS,LI_SURVIVAL_CERTIFICATE",
    route: `${R_LiRoutes.details_PolicyNumber}?action=policyServicesList`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02UPBNKACC",
    name: "LI_ADD_UPDATE_BANK_ACCOUNT",
    route: `${R_LiRoutes.details_PolicyNumber}?action=policyServicesList`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02UPNO",
    name: "LI_UPDATE_NOMINEE",
    route: `${R_LiRoutes.details_PolicyNumber}?action=policyServicesList`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02TRSD",
    name: "LI_APPLICATION_TRACKER,LI_TRACK_CLAIMS",
    route: `${R_LiRoutes.details_PolicyNumber}?action=trackRequestList`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02MS",
    name: "LI_DOWNLOAD_STATEMENTS",
    route: `${R_LiRoutes.details_PolicyNumber}`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["02"],
  },
  {
    funcCode: "02FAQ",
    name: "LI_FAQ_HAMBURGER_MENU",
    route: `${R_HomeRoutes.home}?action=FAQs&module=lifeInsurance`,
    isDynamicPath: true,
    dynamicKeys: [],
    lobCode: ["02"],
  },
  {
    funcCode: "06FAQ",
    name: "HI_FAQ_HAMBURGER_MENU",
    route: `${R_HomeRoutes.home}?action=FAQs&module=healthInsurance`,
    isDynamicPath: true,
    dynamicKeys: [],
    lobCode: ["06"],
  },
  {
    funcCode: "06DMR",
    name: "HI_MY_MEDICAL_REPORTS",
    route: `${R_HiRoutes.details_PolicyNumber_MedicalReports}`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"],
  },
  {
    funcCode: "01HO",
    name: "MF_LANDING_PAGE_HOLDINGS",
    route: `${R_HomeRoutes.home}`,
    isDynamicPath: true,
    dynamicKeys: ["panNumber"],
    lobCode: ["01"],
  },
  {
    funcCode: InAppFeatureFuncCodes.LI_APP_TAX_CERTIFICATE,
    name: "LI_APP_TAX_CERTIFICATE",
    route: `${R_LiRoutes.details_PolicyNumber_TaxCertificate}`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    isEncrypted: true,
    lobCode: ["02"],
  },
  {
    funcCode: "02AUND",
    name: "LI_ADD_UPDATE_NOMINEE",
    route: `${R_LiRoutes.addUpdate_nominee}`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    isEncrypted: true,
    lobCode: ["02"],
  },
  {
    funcCode: "02AUBD",
    name: "LI_ADD_UPDATE_BANK_DETAILS",
    route: `${R_LiRoutes.detail_PolicyNumber_AddUpdateBankAccount}`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    isEncrypted: true,
    lobCode: ["02"],
  },
  {
    funcCode: "AND",
    name: "LI_ADD_NOMINEE_DETAILS",
    route: `${R_LiRoutes.addUpdate_nominee}`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    isEncrypted: true,
  },
  {
    funcCode: InAppFeatureFuncCodes.LI_POLICY_ACCOUNT_STATEMENT,
    name: "LI_POLICY_ACCOUNT_STATEMENT",
    route: `${R_LiRoutes.details_PolicyNumber_PolicyAccountStatement}`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    isEncrypted: true,
    lobCode: ["02"],
  },
  {
    funcCode: InAppFeatureFuncCodes.LI_PREMIUM_RECEIPTS,
    name: "LI_PREMIUM_RECEIPTS",
    route: `${R_LiRoutes.details_PolicyNumber_PremiumReceipts}`,
    isDynamicPath: true,
    dynamicKeys: ["policyNumber"],
    isEncrypted: true,
    lobCode: ["02"],
  },
  {
    funcCode: "04FAQ",
    name: "HL_FAQ",
    route: `${R_HomeRoutes.home}?action=FAQs&module=homeLoan`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: "04LDQA",
    name: "HL_QUICK_ACTION",
    route: `${R_HLRoutes.home_loan_details}?action=quickAction`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: "04WKIT",
    name: "HL WELCOME KIT",
    route: `${R_HLRoutes.home_loan_details}?action=HLStatementsAndDocuments`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: InAppFeatureFuncCodes.HL_STATEMENTS_DOCUMENTS_REPAYMENT_SCHEDULE,
    name: "HL_STATEMENTS_DOCUMENTS_REPAYMENT_SCHEDULE",
    route: `${R_HLRoutes.home_loan_details}?action=HLStatementsAndDocuments`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: InAppFeatureFuncCodes.HL_DISBURSEMENT_REQUEST,
    name: "IN_APP_DISBURSEMENT_REQUEST",
    route: `${R_HLRoutes.disbursement_request}`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: InAppFeatureFuncCodes.HL_IN_APP_EMI_PAYMENT,
    name: "IN_APP_EMI_PAYMENT",
    route: `${R_HLRoutes.emi_payment}`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: InAppFeatureFuncCodes.IN_APP_E_NACH,
    name: "IN_APP_E_NACH",
    route: `${R_HLRoutes.change_enach}`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: InAppFeatureFuncCodes.HL_INTEREST_CERTIFICATE,
    name: "IN_APP_DOWNLOAD_INTEREST_CERTIFICATE",
    route: `${R_HLRoutes.interest_certificate}`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: "04LDQSD",
    name: "IN_APP_LOAN_DETAILS_QUICK_STATEMENT_DOC",
    route: `${R_HLRoutes.home_loan_details}`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: "04LD",
    name: "IN_APP_LOAN_DETAILS",
    route: `${R_HLRoutes.home_loan_details}`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: InAppFeatureFuncCodes.HL_STATEMENT_OF_ACCOUNT,
    name: "IN_APP_DOWNLOAD_STATEMENT_ACCOUNT",
    route: `${R_HLRoutes.account_statement}`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: "04SR",
    name: "IN_APP_HOME_LOAN_SERVICE_REQUEST",
    route: `${R_HLRoutes.home_loan_service_request}`,
    isDynamicPath: true,
    dynamicKeys: ["accountNumber"],
    lobCode: ["04"],
  },
  {
    funcCode: InAppFeatureFuncCodes.GA_DASHBOARD,
    name: "Dashboard",
    route: R_HomeRoutes.home,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: InAppFeatureFuncCodes.GA_SEARCH,
    name: "GA_SEARCH",
    route: `${R_HomeRoutes.home}?action=search`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: InAppFeatureFuncCodes.GA_LOAN_TAB_HOME,
    name: "Dashboard",
    route: `${R_HomeRoutes.home}?activeTab=Loans`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: InAppFeatureFuncCodes.GA_INVESTMENT_TAB_HOME,
    name: "Dashboard",
    route: `${R_HomeRoutes.home}?activeTab=Investment`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24", "25"],
  },
  {
    funcCode: InAppFeatureFuncCodes.GA_INSURANCE_TAB_HOME,
    name: "Dashboard",
    route: `${R_HomeRoutes.home}?activeTab=Insurance`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24", "25"],
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_DETAIL_PAGE,
    name: "Detail Screen",
    route: `${R_HiRoutes.details_PolicyNumber}`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_POLICY_DOCUMENTS,
    name: "HI POLICY DOCUMENTS",
    route: `${R_HiRoutes.details_PolicyNumber}?action=Policy Documents`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_PREMIUMCERTIFICATE,
    name: "HI POLICY DOCUMENTS-> PREMIUMCERTIFICATE",
    route: `${R_HiRoutes.details_PolicyNumber}?action=Policy Documents`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_POLICYSCHEDULE,
    name: "HI POLICY DOCUMENTS-> POLICYSCHEDULE",
    route: `${R_HiRoutes.details_PolicyNumber}?action=Policy Documents`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_POLICYWORDINGS,
    name: "HI POLICY DOCUMENTS-> POLICYWORDINGS",
    route: `${R_HiRoutes.details_PolicyNumber}?action=Policy Documents`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_ECARD,
    name: "HI POLICY DOCUMENTS-> ECARD",
    route: `${R_HiRoutes.details_PolicyNumber}?action=Policy Documents`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_UTILITIES,
    name: "HI UTILITIES",
    route: `${R_HiRoutes.details_PolicyNumber}?action=Utilities`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_CASHLESS_NETWORK_HOSPITAL,
    name: "HI UTILITIES->CASHLESS NETWORK HOSPITAL",
    route: `${R_HiRoutes.details_PolicyNumber}?action=Utilities`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_BMI_CALCULATOR,
    name: "HI UTILITIES->BMI CALCULATOR",
    route: `${R_HiRoutes.details_PolicyNumber}?action=Utilities`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_ACTIVE_AGE_CALCULATOR,
    name: "HI UTILITIES->ACTIVE AGE CALCULATOR",
    route: `${R_HiRoutes.details_PolicyNumber}?action=Utilities`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_PROPOSER_DETAILS,
    name: "EDIT_PAN,PROPOSER_NAME,DOB,GENDER",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=0`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_EDIT_PAN,
    name: "EDIT_PAN",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=0`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_PROPOSER_NAME,
    name: "PROPOSER_NAME",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=0`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_DOB,
    name: "DOB",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=0`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_GENDER,
    name: "GENDER",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=0`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_CONTACT_DETAILS,
    name: "HI_EDIT_MOBILE_NUMBER,ALTERNATE_MOBILE_NUMBER,EMAIL,ADDRESS",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=1`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_EDIT_MOBILE_NUMBER,
    name: "HI_EDIT_MOBILE_NUMBER",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=1`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_ALTERNATE_MOBILE_NUMBER,
    name: "ALTERNATE_MOBILE_NUMBER",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=1`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_EMAIL,
    name: "EMAIL",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=1`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_ADDRESS,
    name: "ADDRESS",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=1`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_UPDATE_NOMINEE,
    name: "UPDATE_NOMINEE",
    route: `${R_HiRoutes.details_PolicyNumber_EditPolicy}?activeTab=2`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_QUICK_ACTION_MAIN_MENU,
    name: "QUICK ACTION MAIN MENU",
    route: `${R_HiRoutes.details_PolicyNumber}?quickAction=true`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_POLICY_RENEWAL,
    name: "POLICY RENEWAL",
    route: `${R_HiRoutes.details_PolicyNumber}?quickAction=true`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_TRACKING_CLAIM,
    name: "TRACKING CLAIM",
    route: `${R_HiRoutes.details_PolicyNumber}?quickAction=true`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_RAISE_CLAIM,
    name: "RAISING CLAIM",
    route: `${R_HiRoutes.details_PolicyNumber}?quickAction=true`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_MY_CLAIM,
    name: "MY CLAIM",
    route: `${R_HiRoutes.details_PolicyNumber}?quickAction=true`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_ABHA_ID,
    name: "CREATE ABHA ID",
    route: `${R_HiRoutes.details_PolicyNumber}?quickAction=true`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_CALL_DOCTOR,
    name: "CALL_DOCTOR",
    route: `${R_HiRoutes.details_PolicyNumber}?quickAction=true`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: InAppFeatureFuncCodes.HI_MY_REQUEST,
    name: "MY_REQUEST",
    route: `${R_HiRoutes.details_PolicyNumber}?quickAction=true`,
    isDynamicPath: false,
    dynamicKeys: ["policyNumber"],
    lobCode: ["06"], //HI LOB
  },
  {
    funcCode: "GAHM",
    name: "GA_HAMBURGER_MENU",
    route: `${R_HomeRoutes.home}?action=hamburgerMenu`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GAMP",
    name: "GA_HAMBURGER_MENU_MY_PROFILE",
    route: `${R_HomeRoutes.home}?action=myProfile`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GAU",
    name: "GA_HAMBURGER_MENU_UTILITIES",
    route: `${R_HomeRoutes.home}?action=utilities`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GAHS",
    name: "GA_HAMBURGER_MENU_HELP_AND_SUPPORT",
    route: `${R_HomeRoutes.home}?action=helpAndSupport`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GAAS",
    name: "GA_HAMBURGER_MENU_APP_SETTINGS",
    route: `${R_HomeRoutes.home}?action=appSettings`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GAL",
    name: "GA_HAMBURGER_MENU_LOGOUT",
    route: `${R_HomeRoutes.home}?action=logout`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GARAB",
    name: "GA_HAMBURGER_MENU_REPORT_A_BUG",
    route: `${R_HomeRoutes.home}?action=helpAndSupport&module=reportABug`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GACU",
    name: "GA_HAMBURGER_MENU_CALL_US",
    route: `${R_HomeRoutes.home}?action=helpAndSupport&module=callUs`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GAEU",
    name: "GA_HAMBURGER_MENU_EMAIL_US",
    route: `${R_HomeRoutes.home}?action=helpAndSupport&module=emailUs`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GAFAQ",
    name: "GA_HAMBURGER_MENU_FAQ",
    route: `${R_HomeRoutes.home}?action=helpAndSupport&module=FAQs`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GACWU",
    name: "GA_HAMBURGER_MENU_CHAT_WITH_US",
    route: `${R_HomeRoutes.home}?action=helpAndSupport&module=chatWithUs`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GARU",
    name: "GA_HAMBURGER_MENU_RATE_US",
    route: `${R_HomeRoutes.home}?action=hamburgerMenu&module=rateUs`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GATNC",
    name: "GA_HAMBURGER_MENU_TERMS_AND_CONDITION",
    route: `${R_HomeRoutes.home}?action=hamburgerMenu&module=termsAndCondition`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GAAMD",
    name: "GA_ADD_MANUALLY_DEFAULT",
    route: `${R_HomeRoutes.home}?action=addManually&module=default`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01", "02", "03", "04", "06", "24"],
  },
  {
    funcCode: "GAAMLI",
    name: "GA_ADD_MANUALLY_LIFE_INSURANCE",
    route: `${R_HomeRoutes.home}?action=addManually&module=lifeInsurance`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["02"],
  },
  {
    funcCode: "GAAMHI",
    name: "GA_ADD_MANUALLY_HEALTH_INSURANCE",
    route: `${R_HomeRoutes.home}?action=addManually&module=healthInsurance`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["06"],
  },
  {
    funcCode: "GAAMMF",
    name: "GA_ADD_MANUALLY_MUTUAL_FUND",
    route: `${R_HomeRoutes.home}?action=addManually&module=mutualFund`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["01"],
  },
  {
    funcCode: "GAAMSS",
    name: "GA_ADD_MANUALLY_STOCKS_AND_SECURITIES",
    route: `${R_HomeRoutes.home}?action=addManually&module=stocksAndSecurities`,
    isDynamicPath: false,
    dynamicKeys: [],
    lobCode: ["24"],
  },
];
export enum E_CampaignIdentifierKeys {
  utm_source = "utm_source",
  utm_medium = "utm_medium",
  utm_campaign = "utm_campaign",
  utm_term = "utm_term",
  utm_content = "utm_content",
  utm_id = "utm_id",
  utm_adid = "utm_adid",
  utm_adgroup = "utm_adgroup",
}
export type T_CampaignHeaders = {
  key: string;
  value: string;
};

export type T_LiRouteState = {
  policyNumber: string;
};
export type T_ErrorEventHandlerState = {
  onClick: undefined | Function;
};
export type T_HiRouteState = {
  policyNumber: string;
};

export type PolicyOrAccountSelectionData = {
  isOpen: boolean;
  options: string[];
  redirectionUrl: string;
  lobDetails: T_ProductCategoryOptions | null;
  functionalityCode?: string;
};
export type isBiometricEnable = { isBiometricEnable: boolean };
export type T_BiometricCapture = isBiometricEnable & {
  biometricToken: string;
};
export type T_BiometricVerify = isBiometricEnable & {
  isBiometricTokenVerified: boolean;
};
export type T_GTMBaseEvents = {
  ClientID: string;
  previous_screen_name: string;
  journey_id: string;
};
export interface NotificationsData {
  preIcon: string;
  title: string;
  description: string;
  date: Date;
  isNotificationRead: boolean;
}
export type T_saveCustomerNavigationPayload = {
  eventName: string;
};

export interface ImageAttributes {
  name: string;
  alternativeText: string | null;
  caption: string | null;
  width: string;
  height: string;
  formats: {
    small: FormatDetails | null;
    thumbnail: FormatDetails | null;
  };
  hash: string;
  ext: string;
  mime: string;
  size: string;
  url: string;
  previewUrl: string | null;
  provider: string;
  provider_metadata: any | null;
  createdAt: string;
  updatedAt: string;
}
export interface FormatDetails {
  ext: string;
  url: string;
  hash: string;
  mime: string;
  name: string;
  path: string | null;
  size: string;
  width: string;
  height: string;
  sizeInBytes: number;
}

export type T_OnUserLoginCleverTapStatic = {
  Name: string;
  Identity: string;
  Email: string;
  Phone: string;
  Gender: "M" | "F" | undefined;
  DOB?: Date | "";
  "MSG-email": boolean;
  "MSG-push": boolean;
  "MSG-sms": boolean;
  "MSG-whatsapp": boolean;
  Stuff: string;
};

export type DocumentAttributes = {
  name: string;
  hash: string;
  ext: string;
  mime: string;
  size: string;
  url: string;
  pdfBytes?: string;
  provider: string;
  createdAt: string;
  updatedAt: string;
};
